import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import favicon from '../assets/icons/favicon.ico'
import '../styles/index.scss'
import '../styles/bootstrap-grid.min.css'

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      meta={[
        { name: 'description', content: 'INTELLLEX support' },
        { name: 'keywords', content: 'Intelllex, support, faq, SOURCE, STACKS, SYNC' },
      ]}
    >
      <title>Support INTELLLEX</title>
      <link rel="shortcut icon" href={favicon} type="image/vnd.microsoft.icon" />
    </Helmet>
    <div>
      {children()}
    </div>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js